import CloseIcon from '@material-design-icons/svg/filled/close.svg?react';
import { twMerge } from 'tailwind-merge';

interface RemoveButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  ariaLabel: string;
  className?: string;
}

export function RemoveButton({
  onClick,
  ariaLabel,
  className,
}: RemoveButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={twMerge(
        'group',
        'absolute top-1.5 right-1.5',
        'p-1 bg-black bg-opacity-50 rounded-full text-white',
        'hover:bg-opacity-75 hover:scale-110',
        'active:scale-125',
        'focus:outline-none',
        'z-10 pointer-events-auto',
        'transition-all duration-200 ease-in-out',
        className,
      )}
      aria-label={ariaLabel}
    >
      <div className="transition-transform duration-200 ease-in-out group-hover:rotate-90">
        <CloseIcon className="size-4 fill-current" />
      </div>
    </button>
  );
}
